import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { track } from "../../lib/analytics";

export function OrderSuccessPage() {
  const { t } = useTranslation();
  useEffect(() => {
    track("order_paid");
  }, []);
  return (
    <div className="card p-10 text-center max-w-md mx-auto">
      <div className="text-6xl mb-3">🎉</div>
      <h1 className="font-display text-2xl font-semibold tracking-tight">{t("orders.success")}</h1>
      <Link to="/app/orders" className="btn-primary mt-6 inline-flex">{t("nav.orders")}</Link>
    </div>
  );
}
